import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// utils
import { stringAvatar } from "./utils";
import { isEmpty } from "../../utils";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#505050",
    color: "#fff",
    // color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  "&.MuiAvatar-root": {},
}));

//
const AvatarTooltip = ({ tooltipProps, avatarProps }) => {
  // style
  const classes = useStyles();
  // props
  const { letter, src } = avatarProps;

  // local state

  return (
    (!isEmpty(tooltipProps) && (
      <DarkTooltip title="Add" placement="right" {...tooltipProps}>
        <StyledAvatar {...stringAvatar(letter)} {...avatarProps} />
      </DarkTooltip>
    )) || <StyledAvatar {...stringAvatar(letter)} {...avatarProps} />
  );
};

AvatarTooltip.propTypes = {
  tooltipProps: PropTypes.objectOf(PropTypes.any),
  avatarProps: PropTypes.objectOf(PropTypes.any),
};

AvatarTooltip.defaultProps = {
  tooltipProps: {},
  avatarProps: {},
};

export default AvatarTooltip;
